import React from "react";
export default function Tags() {
  return (
    <div>
      <h4 className="pages-h4">Tags</h4>
    </div>
  );
}
